import Clipboard from 'stimulus-clipboard';

export default class extends Clipboard {
  static targets = ['button', 'source'];

  static values = {
    successDuration: {
      type: Number,
      default: 500,
    },
    successContent: {
      type: String,
      default: '',
    },
  };

  connect() {
    super.connect();
  }

  async copy(event) {
    event.preventDefault();
    await navigator.clipboard.writeText(this.sourceTarget.value);
    this.copied();
  }

  async copyForApp(event) {
    event.preventDefault();
    Android.writeToClipboard(this.sourceTarget.value)
    this.copied();
  }

  copied() {
    if (!this.hasButtonTarget) return;
    if (this.successContentValue === '') return;
    window.$sendNotice(this.successContentValue);
  }
}
